<template>
<div class="adddrawingwrapper">
    <div class="drawinginputs" v-loading="loading">
      <div class="div-block-39">
        <div class="div-block-40">
          <div class="text-block-22">Add Design Drawing</div><a href="#" class="link-block-6 w-inline-block" @click="$emit('close-add-drawing')"><img src="../../static/images/cancel.png" width="32" height="32" class="image-6"></a></div>
        <div class="adddrawinginputs" v-if="knowledgeBaseReady" id="form-window">
          <el-form ref="generalForm" :model="form_instance" :rules="generalRules" label-position="left" label-width="80px">
            <h3 id="form-top">General</h3>
            <el-form-item label="Page #" prop="page_id" inline-message="true">
              <el-input v-model="form_instance.page_id" style="width: 200px; margin-left:12px;" clearable :autofocus="true"></el-input>
              <div v-show="duplicatePageId" style="color:#c62828;">Page Id already exists</div>
            </el-form-item>
            <el-form-item label="Revision" prop="revision">
              <el-date-picker type="date" placeholder="Enter Revision" v-model="form_instance.revision" value-format="yyyy-MM-dd" style="width: 200px; margin-left:12px;"></el-date-picker>
            </el-form-item>
            <el-form-item label="Type" prop="type">
              <el-row>
                <el-col>
                  <el-radio-group v-model="form_instance.type" style="margin-left:12px;">
                    <el-radio-button label="Kitchen"></el-radio-button>
                    <el-radio-button label="Vanity"></el-radio-button>
                    <el-radio-button label="Other"></el-radio-button>
                  </el-radio-group>
                </el-col>
                <el-col :span="20" style="margin-top: 12px;">
                  <el-input v-model="form_instance.detail_type" placeholder="VA3921(WALL ON LEFT)" style="margin-left:12px;" clearable>
                    <template slot="prepend">Type Specification</template>
                  </el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <h3>Units</h3>
            <el-form-item
              v-for="(unit, index) in form_instance.units"
              :label="'Unit ' + (index + 1)"
              :key="unit.key"
              prop="unit">
              <el-row :gutter="20" style="width: 95%; margin-top: 16px;">
                <el-col :span="12">
                  <el-radio-group v-model="unit.type">
                    <el-radio-button label="Public"></el-radio-button>
                    <el-radio-button label="Studio"></el-radio-button>
                    <el-radio-button label="1 BED"></el-radio-button>
                    <el-radio-button label="2 BED"></el-radio-button>
                    <el-radio-button label="3 BED"></el-radio-button>
                    <el-radio-button label="Other"></el-radio-button>
                  </el-radio-group>
                </el-col>
                <el-col :span="8" v-model="unit.other_type">
                  <el-input v-if="unit.type === 'Other'" placeholder="Unit Type" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button type="danger" icon="el-icon-delete" @click="removeUnit(unit)" tabindex="-1" plain circle></el-button>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="width: 95%; margin-top: 16px; margin-left: 0;">
                <el-col :span="10">
                  <el-input placeholder="Building: default if leave blank" v-model="unit.building" clearable>
                    <template slot="prepend">B</template>
                  </el-input>
                </el-col>
                <el-col :span="10">
                  <el-input placeholder="Only one tier" v-model="unit.tier" clearable>
                    <template slot="prepend">T</template>
                  </el-input>
                </el-col>
                <el-col :span="10" style="margin-top: 12px">
                  <el-input placeholder="3-7,11,20-21" v-model="unit.floor" clearable>
                    <template slot="prepend">L</template>
                  </el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-button type="primary" plain round style="margin-left: 92px;" @click="addUnit">Add Unit</el-button>
            <el-row style="width: 80%; margin-top: 16px; margin-left: 92px;">
              <div>
                <span style="font-weight: bold;"> Unit Covered: </span>
                <span v-for="unit in units_set" :key="unit.key"> {{ unit.display }} </span>
              </div>
            </el-row>
          </el-form>
          <div>
            <h3>Items</h3>
            <el-form v-for="(item, index) in form_instance.items"
              :ref="`itemForm${index}`"
              :model="item"
              :rules="itemRules"
              label-position="left"
              :key="item.key">
              <div style="display: flex;">
              <div style="min-width: 80px; width: 80px; font-size: 14px; color: #606266; line-height: 40px; padding: 0 12px 0 0; box-sizing: border-box; font-weight: bold">Item {{ index + 1 }}</div>
              <el-row :gutter="20" style="margin-left: 0">
                <el-col :span="9">
                  <el-form-item prop="model">
                    <el-autocomplete placeholder="Item Code" style="width: 100%;"
                      v-model="item.model" clearable
                      :fetch-suggestions="suggestItem"
                      :trigger-on-focus="true"
                      :id="'focus-control-' + index"
                      @select="selectItem(item,index)">
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item prop="qty">
                    <el-input-number :min="0" v-model="item.qty" label="Item Qty." :precision="1" :controls="false" style="width: 100%;"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="remark">
                    <el-input placeholder="Leave any remark here"
                      v-model="item.remark" label="Remark."
                      :clearable="true" style="width: 100%;">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-button type="danger" icon="el-icon-delete" @click="removeItem(item)" tabindex="-1" plain circle></el-button>
                </el-col>
              </el-row>
              </div>
              <el-row :gutter="20" style="margin-left: 80px;">
                <el-col :span="18">
                  <el-form-item prop="color">
                    <el-autocomplete placeholder="Color Spec." style="width: 100%;"
                      v-model="item.color" :clearable="true"
                      :fetch-suggestions="suggestColor"
                      :trigger-on-focus="true"
                      @select="selectColor(item,index)">
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-color-picker v-model="item.tag"></el-color-picker>
                </el-col>
              </el-row>
            </el-form>
            <el-button type="primary" plain round style="margin-left: 92px;" @click="addItem">Add Item</el-button>
          </div>
            <h3>Note</h3>
            <div label="Note">
              <el-row style="width: 95%; margin-left:12px;">
                <el-col :span="22">
                  <el-input
                  type="textarea"
                  :autosize="{ minRows: 4}"
                  placeholder="You can leave any note here"
                  v-model="form_instance.note">
                </el-input>
                </el-col>
              </el-row>
            </div>
        </div>
      </div>
      <div class="adddrawingbuttons">
        <el-button type="primary" round plain @click="clickNext" :disabled="duplicatePageId">Next Drawing</el-button>
        <el-button type="primary" round @click="clickSubmit" :disabled="duplicatePageId">Done</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import parseUnit from '../../static/js/parseUnit'
import drawingService from '../../static/js/drawing'

export default {
  name: 'AddDrawingForm',
  data () {
    return {
      loading: false,
      form_instance: {
        page_id: '',
        revision: '',
        type: '',
        detail_type: '',
        items: [{
          model: '',
          color: '',
          tag: '#92D050',
          qty: 1,
          remark: '',
          key: Date.now()
        }],
        units: [{
          type: '',
          tier: '',
          building: 'Default',
          floor: '',
          other_type: ''
        }],
        note: ''
      },
      knowledgeBase: {},
      knowledgeBaseReady: false,
      generalRules: {
        page_id: [
          {required: true, message: 'Please enter a page number', trigger: 'blur'}
        ],
        revision: [
          {required: true, message: 'Please select an revision', trigger: 'blur'}
        ],
        type: [
          {required: true, message: 'Please select a type', trigger: 'blur'}
        ]
      },
      itemRules: {
        model: [
          {required: true, message: 'Please select a model', trigger: 'change'}
        ],
        color: [
          {required: true, message: 'Please enter the color', trigger: 'change'}
        ]
      }
    }
  },
  mounted: async function () {
    if (this.projectData.id) {
      await drawingService.initService(this.projectData.id)
      // console.log('result', result)
      this.knowledgeBase = await drawingService.fetchProjectKnowledgeBase(this.projectData.id)
      // console.log('knowledge base ready')
      this.knowledgeBaseReady = true
    }
  },
  props: ['projectData', 'existsPageIds'], // D
  methods: {
    addItem: function () {
      var newItem = this.form_instance.items.slice(-1)[0]
      this.form_instance.items.push({
        model: '',
        color: newItem.color,
        tag: newItem.tag,
        qty: 1,
        remark: '',
        key: Date.now()
      })
    },
    removeItem: function (item) {
      var index = this.form_instance.items.indexOf(item)
      if (index !== -1 && this.form_instance.items.length > 1) {
        this.form_instance.items.splice(index, 1)
      }
    },
    addUnit: function () {
      this.form_instance.units.push({
        type: '',
        tier: '',
        building: 'Default',
        floor: '',
        other_type: ''
      })
    },
    removeUnit: function (unit) {
      var index = this.form_instance.units.indexOf(unit)
      if (index !== -1 && this.form_instance.units.length > 1) {
        this.form_instance.units.splice(index, 1)
      }
    },
    clickSubmit: function () {
      if (this.validateForm()) {
        this.saveNewDrawing()
      }
    },
    clickNext: function () {
      if (this.validateForm()) {
        this.saveAndNext()
      }
    },
    saveNewDrawing: async function () {
      // save drawing
      this.loading = true
      let drawing = {
        projectId: this.projectData.id,
        pageId: this.form_instance.page_id,
        revision: this.form_instance.revision,
        type: this.form_instance.type,
        detailType: this.form_instance.detail_type,
        note: this.form_instance.note,
        units: this.units_set,
        items: this.form_instance.items
      }

      // console.log(drawing)
      let result = await drawingService.saveDrawing(drawing)
      if (result) {
        this.$emit('close-add-drawing')
      } else {
        // this.$notify({
        //   title: 'Error',
        //   message: 'Unable to save the drawing, please try again.',
        //   type: 'error',
        //   duration: 3000,
        //   offset: 64
        // })
      }
    },
    saveAndNext: async function () {
      // save drawing
      this.loading = true
      let drawing = {
        projectId: this.projectData.id,
        pageId: this.form_instance.page_id,
        revision: this.form_instance.revision,
        type: this.form_instance.type,
        detailType: this.form_instance.detail_type,
        note: this.form_instance.note,
        units: this.units_set,
        items: this.form_instance.items
      }

      // console.log(drawing)
      let result = await drawingService.saveDrawing(drawing)
      if (result) {
        this.loading = false
        this.clearForm(drawing.revision)
      } else {
        // this.$notify({
        //   title: 'Error',
        //   message: 'Unable to save the drawing, please try again.',
        //   type: 'error',
        //   duration: 3000,
        //   offset: 64
        // })
      }
    },
    clearForm: function (revision) {
      // clear form
      let that = this
      this.form_instance = {
        page_id: '',
        revision: revision,
        type: '',
        detail_type: '',
        items: [{
          model: '',
          color: '',
          tag: '#92D050',
          qty: 1,
          remark: '',
          key: Date.now()
        }],
        units: [{
          type: '',
          tier: '',
          building: 'Default',
          floor: '',
          other_type: ''
        }],
        note: ''
      }
      setTimeout(() => {
        that.scrollToTop()
      }, 100)
    },
    validateForm: function () {
      if (this.duplicatePageId) {
        this.$message.error('Some information is invalid')
        return false
      }
      let validNeeds = 1 + this.form_instance.items.length
      let validCount = 0
      // console.log(this.$refs['generalForm'])
      this.$refs['generalForm'].validate(valid => {
        if (valid) {
          validCount++
        }
      })
      for (var i = 0; i < this.form_instance.items.length; i++) {
        this.$refs[`itemForm${i}`][0].validate(valid => {
          if (valid) {
            validCount++
          }
        })
      }
      if (validCount === validNeeds) {
        // console.log('all validate passed')
        return true
      } else {
        this.$message.error('Some information is invalid')
        return false
      }
    },
    suggestItem: function (queryString, cb) {
      var items = this.suggestItems
      var results = queryString ? items.filter(this.itemFilter(queryString)) : items
      cb(results)
    },
    itemFilter: function (queryString) {
      return (item) => {
        return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    selectItem: function (item, index) {
      // console.log('select item: ', item, index)
    },
    suggestColor: function (queryString, cb) {
      var colors = this.suggestColors
      var results = queryString ? colors.filter(this.colorFilter(queryString)) : colors
      cb(results)
    },
    colorFilter: function (queryString) {
      return (color) => {
        return (color.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    selectColor: function (item, index) {
      for (let color of this.suggestColors) {
        if (color.color === item.color) {
          this.form_instance.items[index].tag = color.tag
        }
      }
    },
    scrollToTop: function () {
      // eslint-disable-next-line
      let cancelScroll = this.$scrollTo('#form-top', 300, {
        container: '#form-window'
      })
      // cancelScroll() // comment out to cancel scroll
    }
  },
  computed: {
    units_set: function () {
      // console.log('parsing units...')
      return parseUnit(this.form_instance.units)
    },
    suggestItems: function () {
      let itemBase = this.knowledgeBase.itemBase
      let modelList = []
      for (let item of itemBase) {
        let model = item.model
        if (!modelList.includes(model)) {
          modelList.push(item.model)
        }
      }
      let list = modelList.map(model => {
        return {
          value: model,
          model: model
        }
      })
      return list
    },
    suggestColors: function () { // D
      let colorBase = this.knowledgeBase.colorBase
      let list = []
      for (let color of colorBase) {
        let colorName = color.name
        if (list.findIndex(color => { return color.value === colorName }) === -1) {
          list.push({
            value: color.name,
            color: color.name,
            tag: color.tag
          })
        }
      }
      return list
    },
    duplicatePageId: function () {
      if (this.form_instance.page_id === '') {
        return false
      }
      if (this.existsPageIds.indexOf(this.form_instance.page_id.toLowerCase()) !== -1) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    projectData: async function () {
      if (this.projectData.id) {
        await drawingService.initService(this.projectData.id)
        // console.log('result', result)
        this.knowledgeBase = await drawingService.fetchProjectKnowledgeBase(this.projectData.id)
        // console.log('knowledge base ready')
        this.knowledgeBaseReady = true
      }
    }
  }
}

// var focusTo = function (parentId) {
//   let inputElement = document.getElementById(parentId)
//   // console.log(inputElement)
//   inputElement.focus()
// }
</script>

<style scoped>
@media screen and (max-width: 767px) {
  .adddrawingwrapper {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddDrawingForm.vue